import { render } from "./InlineEditTable.vue?vue&type=template&id=90d31986&scoped=true"
import script from "./InlineEditTable.vue?vue&type=script&lang=ts"
export * from "./InlineEditTable.vue?vue&type=script&lang=ts"

import "./InlineEditTable.vue?vue&type=style&index=0&id=90d31986&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-90d31986"

export default script